const internationalPaymentConfigTypes = {
  ADD_BANK_ACCOUNT_REQUEST: 'ADD_BANK_ACCOUNT_REQUEST',
  ADD_BANK_ACCOUNT_SUCCESS: 'ADD_BANK_ACCOUNT_SUCCESS',
  ADD_BANK_ACCOUNT_FAILURE: 'ADD_BANK_ACCOUNT_FAILURE',

  GET_BANK_ACCOUNT_REQUEST: 'GET_BANK_ACCOUNT_REQUEST',
  GET_BANK_ACCOUNT_SUCCESS: 'GET_BANK_ACCOUNT_SUCCESS',
  GET_BANK_ACCOUNT_FAILURE: 'GET_BANK_ACCOUNT_FAILURE'
};

export default internationalPaymentConfigTypes;
